import React, { ReactNode, useCallback } from 'react';
import { Layout } from 'antd';
import { observer } from 'mobx-react-lite';
import { ScrollRestoration } from 'react-router-dom';

import { SideMenu } from '../../side-menu';
import { Header } from './header';

import styles from './base.module.css';

const { Sider } = Layout;

type TBaseLayoutProps = {
  header: string;
  children: ReactNode;
};

const MainMenu = observer(() => {
  const savedCollapseState =
    (localStorage.getItem('is-side-menu-collapse') as 'show' | 'hide') ||
    'show';
  const [menuCollapsed, setCollapsed] = React.useState<'show' | 'hide'>(
    savedCollapseState,
  );

  const changeCollapsed = useCallback(() => {
    const nextToggleState = menuCollapsed === 'show' ? 'hide' : 'show';

    setCollapsed(nextToggleState);
    localStorage.setItem('is-side-menu-collapse', nextToggleState);
  }, [menuCollapsed]);

  const isMenuCollapsed = menuCollapsed === 'hide';

  return (
    <Sider
      width="250"
      theme="light"
      collapsible={true}
      collapsed={isMenuCollapsed}
      draggable={false}
      onCollapse={changeCollapsed}
    >
      <SideMenu isCollapsed={isMenuCollapsed} />
    </Sider>
  );
});

export const BaseLayout = observer(({ header, children }: TBaseLayoutProps) => {
  return (
    <div className={styles.root}>
      <Header title={header} />
      <div className={styles.body}>
        <MainMenu />

        <main className={styles.content}>
          {children}
          <ScrollRestoration />
        </main>
      </div>
    </div>
  );
});
